import { getOsAndVersion, countryCodesToNames } from 'src/utils'

// Debounces a function using the provided time
export const debounce = (fn = () => {}, time = 500) => {
  let timeout;

  return function(...args) {
    const debounced = () => fn.apply(this, args);
    clearTimeout(timeout);
    timeout = setTimeout(debounced, time);
  };
};

export const delay = (ms = 500, val) => new Promise(res => setTimeout(() => res(val), ms));

export const isValidStyleId = (id) => {
  return id && id.length === 10 && /\d/.test(id);
};

export const applyStyleIdsToSpecificComponents = (components, params) => {
  const maxStyleIdCount = 3;
  for (let i = 1; i <= maxStyleIdCount; i++) {
    const styleIdKey = `styleId${i}`;
    const styleIdValue = params.get(styleIdKey);

    if (isValidStyleId(styleIdValue) && components.length >= i) {
      components[i - 1].grkStyleId = styleIdValue;
    }
  }
};

export const mergeUrlParameters = (urlObj, params, grkBlockNumber) => {
  params.forEach((value, key) => {
    if (!urlObj.searchParams.has(key)) {
      urlObj.searchParams.set(key, value);
    }
  });

  if (grkBlockNumber && grkBlockNumber > 0) {
    urlObj.searchParams.set('use', grkBlockNumber.toString());
  }
};

export const getIgnoredParams = (urlParams, necessaryParams = ['articleId']) => {
  return Array.from(urlParams.keys()).filter(p => !necessaryParams.includes(p)).join(',');
};

export const applyKeywordMacros = (keywords = [], macroValues) => {
  const country = macroValues?.country && macroValues.country !== "-"
  && countryCodesToNames ? countryCodesToNames[macroValues.country] : "";
  const state = macroValues.state != "-" ? macroValues.state : "";
  const city = macroValues.city != "-" ? macroValues.city : "";


  const appliedKeywords = (Array.isArray(keywords) ? keywords : []).filter(Boolean).map(keyword => {
    if (typeof keyword !== 'string') return '';

    const macroList = keyword.match(/--\w+--/g);
    if (macroList && macroList.length > 0) {
      macroList.forEach(macro => {
        switch (macro) {
          case '--country--':
            keyword = keyword.replace(macro, country || "");
            break;
          case '--state--':
            keyword = keyword.replace(macro, state || country || "");
            break;
          case '--city--':
            keyword = keyword.replace(macro, city || state || country || "");
            break;
          case '--os--':
            keyword = keyword.replace(macro, getOsAndVersion() || "");
            break;
          default:
            keyword = keyword.replace(macro, '');
            break;
        }
      });
      return keyword;
    } else return keyword;
  });
  return appliedKeywords;
};

export const applyAlias = (children, alias) => {
  const navComponentV2 = children.find(el => el.name === "navComponentV2");
  const index = children.indexOf(navComponentV2);
  if (navComponentV2?.props?.navComponentV2Logo) {
    children[index].props.navComponentV2Logo = children[index].props.navComponentV2Logo.replace("airfind.com", alias);
  }
  if (navComponentV2?.props?.navComponentV2Footer) {
    children[index].props.navComponentV2Footer = children[index].props.navComponentV2Footer.replace("airfind.com", alias);
  }
}
